import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import * as React from "react";
import { ConfidenceEditorialItem } from "components/flexComponents/Content/factory/impl/items/ConfidenceEditorialItem";
import DefaultEditorial from "components/flexComponents/Content/factory/impl/editorials/DefaultEditorial";
import EditorialItemModel from "components/flexComponents/Content/factory/impl/items/EditorialItemModel";

export class ConfidenceEditorial extends DefaultEditorial {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public getItem(model: EditorialItemModel): JSX.Element {
    return (
      <ConfidenceEditorialItem
        id={model.id}
        text={model.text}
        uitkIconName={model.uitkIconName}
        key={`${this.contentPurpose}-${this.keyHelper.next()}`}
      />
    );
  }

  public getEditorialItemClassName = (): string =>
    "Editorial all-cell-1-1 uitk-cell confidenceMessage all-y-padding-three";
}

export default ConfidenceEditorial;
